import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RecommendationQuestionsPageRoutingModule } from './recommendation-questions-routing.module';

import { RecommendationQuestionsPage } from './recommendation-questions.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RecommendationQuestionsPageRoutingModule,
    ReactiveFormsModule
  ],
  declarations: [RecommendationQuestionsPage]
})
export class RecommendationQuestionsPageModule {}
